import { Component, signal, inject, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { UserStore } from './store/user/user.store'
import { BrandingService } from './services/branding.service'
import { BrandingNotFoundComponent } from './components/branding-not-found/branding-not-found.component'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BrandingNotFoundComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private userStore = inject(UserStore)
  protected readonly branding = inject(BrandingService)
  protected readonly title = signal('portal-medico')

  ngOnInit(): void {
    if (this.branding.loadState() === 'not-found') return
    this.userStore.restoreSessionFromStorage()
  }
}
